/* eslint-disable import/no-anonymous-default-export */
import { QuoteShow } from './QuoteShow';
import { QuoteList } from './QuoteList';
import { EstimatorPage } from '@/modules/estimator/EstimatorPage';
import { QuoteFolderShow } from './QuoteFolderShow';
import { Quote } from '@/types';

export default {
    list: QuoteList,
    show: QuoteShow,
    edit: EstimatorPage,
    create: EstimatorPage,
    recordRepresentation: (record: Quote) =>
        record?.description,
};
